import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import '../../Box/Components/Box-Style.css'

function CardBox($title,$description) {

    return (
      <Box sx={CardWrapper}>
        <Box sx={TitleWrap} className="sub-title normal"  variant="h7" dangerouslySetInnerHTML={{__html: $title }}></Box>
        <Box sx={TextWrap} className="normal"  dangerouslySetInnerHTML={{__html: $description }}></Box>
      </Box>
    );
};


const CardWrapper = {
    // paddingBottom: "20px",
    // paddingTop: "20px",
    background: "#FFFFFF",
    height: "100%",
    // border: "#ebebeb solid 1px",
    // background: "#FFFFFF",
    // boxShadow: "0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%)",
}

const TitleWrap = {
    textAlign: "left !important",
    fontWeight: "bold",
}

const TextWrap = {
    // paddingTop: "5px",
    textAlign: "left",
}

export default CardBox;